import methods from './attrs/methods'

export default {
    name: 'CookiesAlert',
    methods
}
